import { styled } from "@mui/material/styles";

export const Component = styled("span", {
  label: "hidden",
})`
  flex: 1;
`;
